import { z } from 'zod/v4';

export const KharonEntitySchema = z.object({
  id: z.string(),
  kharonEntityId: z.string(),
  entityName: z.string().nullable(),
  riskLabels: z.array(z.string()).nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  address: z.string().nullable(),
  url: z.string().nullable(),
  generatedDate: z.date().nullable(),
  sourceText: z.string(),
  sourceTextHash: z.string(),
  aliases: z.array(z.string()).nullable(),
  additionalInformation: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.date(),
  lastCheckedAt: z.date(),
});

export type KharonEntity = z.infer<typeof KharonEntitySchema>;

export const UpsertKharonEntityParamsSchema = KharonEntitySchema;
export type UpsertKharonEntityParams = KharonEntity;
